import { useNavigate } from "react-router-dom";
import { SHORT_TERM_OPTIONS, formatInr } from "../public/pricingPlansConfig";
import "./FreemiumPaywall.css";

const SHORT_FROM = SHORT_TERM_OPTIONS[0]?.price ?? 500;
const QUARTERLY_PRICE = 3000;

const SHORT_FEATURES = [
  "Contact caregivers directly",
  "Hire and book from Marketplace",
  "Upgrade later — pay only the difference",
];

const QUARTERLY_FEATURES = [
  "3 months marketplace access",
  "Unlimited search and contact",
  "Priority support and replacement help",
];

export default function FreemiumPaywall({ open, onClose, onSubscribed, resumeBooking = false }) {
  const navigate = useNavigate();

  if (!open) return null;

  function withResume(path) {
    if (!resumeBooking) return path;
    const join = path.includes("?") ? "&" : "?";
    return `${path}${join}resumeBooking=1`;
  }

  function goPricing(planId) {
    onSubscribed?.();
    onClose?.();
    if (planId === "long") {
      navigate(withResume("/pricing/checkout?plan=long"));
      return;
    }
    if (planId === "short") {
      navigate(withResume(`/pricing/checkout?plan=short&pack=${SHORT_TERM_OPTIONS[0]?.id || "3"}`));
      return;
    }
    navigate(withResume("/pricing"));
  }

  return (
    <div className="freemium-paywall" role="dialog" aria-modal="true" aria-labelledby="freemium-paywall-title">
      <button type="button" className="freemium-paywall__backdrop" aria-label="Close" onClick={onClose} />
      <div className="freemium-paywall__panel">
        <button type="button" className="freemium-paywall__close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <span className="freemium-paywall__badge">Care Pass required</span>
        <h2 id="freemium-paywall-title">Choose a Care Pass to contact or hire</h2>
        <p className="freemium-paywall__lead">
          Free Care Pass lets you browse and compare caregiver profiles. To call, chat, or hire, pick a
          Short-term or Quarterly Care Pass.
        </p>

        <div className="freemium-paywall__plans">
          <article className="freemium-paywall__plan">
            <p className="freemium-paywall__plan-eyebrow">Temporary recovery</p>
            <h3>Short-term Care Pass</h3>
            <p className="freemium-paywall__price">
              From ₹{formatInr(SHORT_FROM)}
            </p>
            <p className="freemium-paywall__validity">Mini · Weekly · Fortnight · Monthly</p>
            <ul>
              {SHORT_FEATURES.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <button
              type="button"
              className="freemium-paywall__plan-cta freemium-paywall__plan-cta--ghost"
              onClick={() => goPricing("short")}
            >
              View short-term passes
            </button>
          </article>

          <article className="freemium-paywall__plan freemium-paywall__plan--featured">
            <p className="freemium-paywall__plan-eyebrow">Best value</p>
            <h3>Quarterly Care Pass</h3>
            <p className="freemium-paywall__price">₹{formatInr(QUARTERLY_PRICE)}</p>
            <p className="freemium-paywall__validity">Valid for 3 months</p>
            <ul>
              {QUARTERLY_FEATURES.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <button
              type="button"
              className="freemium-paywall__plan-cta"
              onClick={() => goPricing("long")}
            >
              Start quarterly Care Pass
            </button>
          </article>
        </div>

        <button type="button" className="freemium-paywall__cta" onClick={() => goPricing()}>
          Compare all plans
        </button>
        <button type="button" className="freemium-paywall__secondary" onClick={onClose}>
          Keep browsing
        </button>
      </div>
    </div>
  );
}
